import { GetterTree } from 'vuex'

import { ILabsState, IRootState, IUserFlag, IStringKeys } from '@/@types'

const getters: GetterTree<ILabsState, IRootState> = {
  userFlags(state) {
    return state.userCurrentFlags?.reduce((acc: IStringKeys, f: IUserFlag) => {
      acc[f.uuid] = f
      return acc
    }, {})
  },
  currentLabSession: state => {
    return state.currentLabSession
  },
}
export default getters
